// userApi.js
import axios from "axios";
import {getAuthHeader} from './auth';

 const baseURL =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

export const fetchUserData = async (skip=0, limit=50) => {
  try {
    const response = await axios.get(`${baseURL}/api/user`,{
      params: {skip, limit },
      headers: getAuthHeader(),
    });

    if (response.status >= 500) {
      throw new Error(`Server error (${response.status})`);
    }

    if (response.status === 204 || response.status === 404) {
      console.log(`No user data found (Status: ${response.status})`);
      return null;
    }

    const data = response.data;

    if (!data || typeof data !== "object") {
      console.log("Invalid data format received");
      return null;
    }

    return data;
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw error;
  }
};

export const fetchCombinedUserData = async (skip=0, limit=50, researcherId) => {
  try {
    const response = await axios.get(`${baseURL}/api/user-researcher`,{
      params: {skip, limit, researcherId },
      headers: getAuthHeader(),
    });

    // Handle HTTP errors manually if needed
    if (response.status >= 500) {
      throw new Error(`Server error (${response.status})`);
    }

    if (response.status === 204 || response.status === 404) {
      console.log(`No user data found (Status: ${response.status})`);
      return null;
    }

    const data = response.data;

    if (!data || typeof data !== "object") {
      console.log("Invalid data format received");
      return null;
    }

    return data;
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw error;
  }
};
export const fetchListsDetails = async () =>{
  try{
    const res = await axios.get(`${baseURL}/api/get-lists`, {
        headers: getAuthHeader()
      });
    return res.data;
  }catch (error) {
    console.error("Error fetching lists");
  }
};

export const fetchReminderDetails = async () =>{
  try{
    const res = await axios.get(`${baseURL}/api/reminders`, {
          headers: getAuthHeader(),
        });
      return res.data;
  } catch(error) {
    console.error("Error fetching lists");
  }
}